import UaParser from "ua-parser-js"

export default {
  namespaced: true,
  state: {
    data: {}
  },
  mutations: {
    get(state) {
      state.data = new UaParser().getResult()
    }
  }
}
